import { CredentialItem } from './credential-item'

export class ProofOfBirthCredentialItem extends CredentialItem {

  public constructor(data: any) {
    super(data)

    const value = this.credential.eligibility_status
    switch (value) {
      case 'pending': {
        this.setStatusTag({ color: 'yellow', value })
        break
      }
      case 'rejected': {
        this.setStatusTag({ color: 'red', value })
        break
      }
      case 'approved': {
        this.validityLabel = `Approved ${this.getDate(this.credential.completed_at)}`
        this.setStatusTag({ value })
        break
      }
      default: this.defaultStatusTag()
    }
  }

}
